import { createFileRoute, redirect } from "@tanstack/react-router";

import { simpleCampaignsQueryOptions } from "@/api/campaign.api";
import { hasRole, isAdmin } from "@/services/auth.service";
import { UserRole } from "@/types/user";

export const Route = createFileRoute("/_dashboard/")({
  beforeLoad: async ({ context }) => {
    const { user } = context;

    const campaigns = await context.queryClient.ensureQueryData(
      simpleCampaignsQueryOptions,
    );

    if (!campaigns || campaigns.length === 0) {
      throw redirect({
        to: "/start",
        replace: true,
      });
    }

    const isSales = hasRole(user, UserRole.Sales);

    if (isAdmin(user)) {
      throw redirect({
        to: "/campaigns",
        replace: true,
      });
    }

    if (isSales) {
      throw redirect({
        to: "/leads",
        replace: true,
      });
    }

    throw redirect({
      to: "/performance",
      replace: true,
    });
  },
});
